import React, { Component } from 'react';
import PriceDetails from './FinalCheckComponents/PriceDetails/PriceDetails';
import OrderDetails from './FinalCheckComponents/OrderDetails/OrderDetails';
import * as homeActions from '../../../redux/homeActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as finalCheckActions from '../../../redux/finalCheckActions';
import * as Constants from '../../../utilities/constants/Constants';
import * as pageControllerActions from '../../../redux/pageControllerActions';
import { bindActionCreators } from 'redux';
import { string } from '../../../localization';
import { connect } from 'react-redux';
import './FinalCheck.scss';
import Preview from '../../../components/VanillaDesign/VanillaFinalCheck/Preview';
import * as CookieUtils from '../../../utilities/CookieUtils/CookieUtils';
import FeedbackDialogue from '../../../components/FeedbackDialogue/FeedbackDialogue';
import * as sideBarTimeUtiles from '../../../utilities/TimerUtils/SidebarTimerUtils';
import * as gaHelpers from '../../../utilities/GAHelpers/GAHelpers';
import LoadingTemplate from '../../../components/LoadingTemplate/LoadingTemplate';
import MediaQuery from 'react-responsive';
import * as signageHelperFunctions from '../../../utilities/HelperFunctions/SignageHelperFunctions';

class FinalCheck extends Component {
  componentDidMount() {
    const {
      feedbackDuration,
      feedbackState,
      isFeedbackVisible,
      dispatchers
    } = this.props;
    const shouldShowFeedback = CookieUtils.resumeFeedbackCookie(
      feedbackDuration
    );

    if (
      (shouldShowFeedback === undefined || !shouldShowFeedback) &&
      feedbackState &&
      isFeedbackVisible
    ) {
      this.startTimer();
    }
    dispatchers.timer.startFinalCheckTimer();
  }

  componentWillUnmount() {
    const { feedbackDuration, feedbackState, isFeedbackVisible } = this.props;
    const shouldShowFeedback = CookieUtils.resumeFeedbackCookie(
      feedbackDuration
    );
    if (
      (shouldShowFeedback === undefined || !shouldShowFeedback) &&
      feedbackState &&
      isFeedbackVisible
    ) {
      this.stopTimer();
    }
    this.handleFinalCheckTimer();
  }

  tick = () => {
    const { dispatchers } = this.props;

    dispatchers.fabricCanvasActions.setFeedbackDialogue(true);
  };

  startTimer = () => {
    const { timeStampForFinalCheck } = this.props;

    this.interval = setInterval(
      this.tick,
      timeStampForFinalCheck * Constants.SECONDS_TIMER
    );
  };

  stopTimer = () => {
    clearInterval(this.interval);
  };

  onEditMaterial = projectIndex => {
    const { dispatchers } = this.props;
    dispatchers.finalCheckActions.editMaterialIsClicked(projectIndex);
  };

  handleFinalCheckTimer = () => {
    const { dispatchers } = this.props;
    dispatchers.gaHelpers.pageChangeGA();
    dispatchers.timer.stopFinalCheckTimer();
  };

  setOrientation = () => {
    const { orientation, projectWidth, projectHeight } = this.props;
    let resultOrientation;
    if (orientation === null) {
      if (projectWidth !== projectHeight) {
        resultOrientation = Constants.PORTRAIT_KEY;
        if (projectWidth > projectHeight) {
          resultOrientation = Constants.LANDSCAPE_KEY;
        }
      }
    } else {
      resultOrientation = orientation;
    }
    return resultOrientation;
  };

  handleFinalCheckTitle = () => {
    const { dispatchers } = this.props;
    if (
      dispatchers.signageHelperFunctions.isTurkeyAccount() ||
      dispatchers.signageHelperFunctions.isBelgiumAccount()
    ) {
      if (dispatchers.signageHelperFunctions.checkForDesignCompetition()) {
        return string.APPLY_DESIGN_COMPETITION;
      }
      return string.SUBMISSION_DESIGN_ORDER;
    }
    return string.REVIEW_AND_SUBMIT_KEY;
  };

  render() {
    const {
      dispatchers,
      category,
      showFeedbackDialogue,
      loadingState,
      blockChainTransactionInProgress
    } = this.props;

    let styleProperty = 'review-submit-potrait-style';
    if (this.setOrientation() === 'Landscape') {
      styleProperty = 'review-submit-landscape-style';
    }
    const styleClassName = `review-submit ${styleProperty}`;
    return (
      <div
        role='button'
        tabIndex='0'
        className='final-check-outer-container'
        onKeyPress={() => {}}
      >
        <div id='final-check'>
          <MediaQuery query='(max-width: 767px)'>
            <div style={{ textAlign: 'center' }}>
              <text className='title arrow-cursor'>
                {this.handleFinalCheckTitle()}
              </text>
            </div>
          </MediaQuery>
          <div className='d-flex final-check-container'>
            <div className={styleClassName}>
              <MediaQuery query='(min-width: 767px)'>
                <div style={{ textAlign: 'center' }}>
                  <text className='title arrow-cursor'>
                    {this.handleFinalCheckTitle()}
                  </text>
                </div>
                {dispatchers.signageHelperFunctions.isTurkeyAccount() ? null : (
                  <p className='double-check-message arrow-cursor'>
                    {string.FINAL_CHECK_DESCRIPTION_STRING_KEY}
                  </p>
                )}
                <div>
                  <button
                    type='button'
                    className='edit-desing-button'
                    onClick={() =>
                      dispatchers.finalCheckActions.onEditDesign(
                        dispatchers.pageControllerActions.setCurrentPageIndex,
                        category
                      )
                    }
                  >
                    {string.EDIT_DESIGN_BUTTON_TITLE_KEY}
                  </button>
                </div>
              </MediaQuery>
              <div className='final-check-preview'>
                <Preview finalcheck />
              </div>
            </div>
            {showFeedbackDialogue ? (
              <FeedbackDialogue
                onDisplay={this.stopTimer}
                onFade={this.startTimer}
              />
            ) : null}
            <div className='finalcheck-right-container'>
              {dispatchers.signageHelperFunctions.canShowPriceDetailsInFinalCheck() ? (
                <PriceDetails
                  onEditMaterial={projectIndex =>
                    this.onEditMaterial(projectIndex)
                  }
                  applicationName={dispatchers.homeActions.applicationName()}
                />
              ) : null}
              <div className='pt-3'>
                <OrderDetails finalCheckTimer={this.handleFinalCheckTimer} />
              </div>
            </div>
          </div>
          {loadingState && blockChainTransactionInProgress ? (
            <LoadingTemplate type={loadingState} />
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    storeData: state.modal.storeData,
    orientation: state.home.orientation,
    category: state.modal.envData.category,
    showFeedbackDialogue: state.fabricCanvas.showFeedbackDialogue,
    feedbackState: state.fabricCanvas.feedbackState,
    timeStampForFinalCheck: state.modal.envData.review_duration,
    feedbackDuration: state.modal.envData.feedback_duration,
    tabTime: state.sideBar.tabTime,
    envData: state.modal.envData,
    isFeedbackVisible: state.modal.storeData.showFeedback,
    projectWidth: state.home.projectWidth,
    projectHeight: state.home.projectHeight,
    loadingState: state.fabricCanvas.loadingState,
    blockChainTransactionInProgress:
      state.fabricCanvas.blockChainTransactionInProgress
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      finalCheckActions: bindActionCreators(finalCheckActions, dispatch),
      signageHelperFunctions: bindActionCreators(
        signageHelperFunctions,
        dispatch
      ),
      timer: bindActionCreators(sideBarTimeUtiles, dispatch),
      gaHelpers: bindActionCreators(gaHelpers, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FinalCheck);
